<template>
  <div>
    <div class="p-lg-3">
      <div class="row">
        <h3 class="mt-0 mb-2 font-weight-bold text-left">
          Relatório de registro de óbitos
        </h3>
      </div>
    </div>

    <v-row align="center" class="my-3">
      <v-col class="d-flex">
        <v-select
            :items="unidades"
            label="Unidade"
            item-value="id"
            v-model="unidadeSelected"
        ></v-select>
      </v-col>
      <v-col class="d-flex">
        <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="datas"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="computedFormatDate"
                label="Data inicial - Data final"
                prepend-icon="mdi-calendar"
                clearable
                v-bind="attrs"
                v-on="on"
                @click:clear="datas = null"
            ></v-text-field>
          </template>
          <v-date-picker
              v-model="datas"
              no-title
              range
              scrollable
              color="green darken-4"
          >
            <v-spacer></v-spacer>
            <v-btn text @click="menu = false"> Cancelar</v-btn>
            <v-btn dark color="success" @click="$refs.menu.save(datas)">
              OK
            </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>

        <v-speed-dial
            v-model="fab"
            :direction="direction"
            :open-on-hover="hover"
        >
          <template v-slot:activator>
            <v-btn
                v-model="fab"
                style="
                color: #fff;
                background-color: #1daf80;
                border-radius: 50px;
              "
                color="blue darken-2"
                dark
                class="btnWid"
            >
              <v-icon v-if="fab"> mdi-close</v-icon>
              <span v-else> Exportar </span>
            </v-btn>
          </template>
          <!--          <v-btn dark color="green" class="btnWid" @click="pdfRelatorioServicosTutor">-->
          <!--            PDF-->
          <!--          </v-btn>-->
          <v-btn dark color="indigo" class="btnWid" @click="excelRelatorioObito()">
            EXCEL
          </v-btn>
        </v-speed-dial>
    </v-row>
    <v-progress-circular v-if="loading"
                         indeterminate
                         color="1daf80"
    ></v-progress-circular>
  </div>
</template>
<script>
import UnidadeService from "@/services/unidade_service";
import ProcedimentoService from "@/services/procedimento_service";
import Mixin from "@/mixins/vuex_mixin.js";

export default {
  mixins: [Mixin],
  data: () => ({
    datas: null,
    menu: false,
    perfil: "",
    direction: "bottom",
    left: false,
    loading: false,
    hover: false,
    fab: false,
    unidades: [],
    unidadeSelected: "",
    services: {
      unidadeService: UnidadeService.build(),
      procedimentoService: ProcedimentoService.build(),
    },
  }),
    beforeMount() {
      this.perfil = JSON.parse(sessionStorage.vuex).perfil.id;
      this.setUnidades();
  },
  computed: {
    computedFormatDate() {
      const datasFormatadas =
          this.datas &&
          this.datas.map((item) =>
              item
                  .split("-")
                  .reverse()
                  .join("/")
          );
      return datasFormatadas;
    },

  },
  methods: {
    setUnidades() {
      console.log(this.unidades)
      this.services.unidadeService
          .getUnidadeByUsuarioLogado()
          .then((response) => {
            return response.json();
          })
          .then((response) => {
            console.log(response)
            this.unidades = response.data.map((unidade) => {
              return {text: unidade.unidade, id: unidade.id_unidade};
            });
          });
    },

    // pdfRelatorioServicosTutor() {
    //   this.loadingTable = true;
    //
    //   const dataInicial = this.datas ? this.datas[0].split("-").join("") : "";
    //   const dataFinal = this.datas ? this.datas[1].split("-").join("") : "";
    //   const unidade = this.unidadeSelected ? this.unidadeSelected : "";
    //   const tipoProcedimento = this.tipoSelected;
    //
    //   const filtroPesquisaIds = this.filtroPesquisaSelected.map(
    //       (item) => item.id
    //   );
    //
    //   if (
    //       !dataInicial ||
    //       !dataFinal ||
    //       !unidade ||
    //       (tipoProcedimento !== 0 && !tipoProcedimento)
    //   ) {
    //     this.$_ACTIONS_showSnackbarMessage({
    //       message: "Preencha os campos corretamente",
    //       color: "error",
    //     });
    //     this.loadingTable = false;
    //     return;
    //   }
    //
    //   this.services.procedimentoService
    //       .pdfRelatorioServicosTutor(
    //           dataInicial,
    //           dataFinal,
    //           unidade,
    //           tipoProcedimento,
    //           filtroPesquisaIds
    //       )
    //       .then((resp) => {
    //         if (resp.status) {
    //           this.$_ACTIONS_showSnackbarMessage({
    //             message: "Falha ao carregar",
    //             color: "error",
    //           });
    //           console.log( dataInicial,
    //               dataFinal,
    //               unidade,
    //               tipoProcedimento,
    //               filtroPesquisaIds)
    //           return;
    //         }
    //         this.$_ACTIONS_showSnackbarMessage({
    //           message: "Dados encontrados com sucesso! Gerando PDF...",
    //           color: "sucess",
    //         });
    //         let link = document.createElement("a");
    //         // link.target = "_blank";
    //         link.download = `${dataInicial}-${dataFinal}.pdf`;
    //         let url = window.URL.createObjectURL(resp);
    //         link.href = url;
    //         link.click();
    //         console.log(resp)
    //       })
    //       .catch(() => {
    //         this.$_ACTIONS_showSnackbarMessage({
    //           message: "Falha ao carregar",
    //           color: "error",
    //         });
    //         console.log( dataInicial,
    //             dataFinal,
    //             unidade,
    //             tipoProcedimento,
    //             filtroPesquisaIds)
    //       })
    //       .finally(() => {
    //         this.loadingTable = false;
    //       });
    // },

    excelRelatorioObito() {
      this.loading = true;

      const dataInicial = this.datas ? this.datas[0].split("-").join("") : "";
      const dataFinal = this.datas ? this.datas[1].split("-").join("") : "";
      const unidade = this.unidadeSelected ? this.unidadeSelected : "";



      if (
          !dataInicial ||
          !dataFinal ||
          !unidade
      ) {
        this.$_ACTIONS_showSnackbarMessage({
          message: "Preencha os campos corretamente",
          color: "error",
        });
        this.loading = false;
        return;
      }

      this.services.procedimentoService
          .excelRelatorioObito(
              dataInicial,
              dataFinal,
              unidade,
          )
          .then((resp) => {
            console.log(resp)
            if (resp.status) {
              this.$_ACTIONS_showSnackbarMessage({
                message: "Falha ao carregar",
                color: "error",
              });
              return;
            }
            this.$_ACTIONS_showSnackbarMessage({
              message:
                  "Dados encontrados com sucesso! Gerando arquivo para Excel...",
              color: "sucess",
            });
            let link = document.createElement("a");
            // link.target = "_blank";
            link.download = `${dataInicial}-${dataFinal}.xlsx`;
            let url = window.URL.createObjectURL(resp);
            link.href = url;
            link.click();
            this.loading = false
          })
          .catch(() => {
            this.$_ACTIONS_showSnackbarMessage({
              message: "Falha ao carregar",
              color: "error",

            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    // limitarCaracteres(string) {
    //   if (string.length > 10) {
    //     return string.substring(0, 10) + "...";
    //   } else {
    //     return string;
    //   }
    // },
  },
}
</script>
<style scoped>
.btnWid {
  width: 7rem;
}
.v-progress-circular {
  margin: 1rem;
  color: #1daf80;
}
</style>